import React, { useEffect, useState } from "react";
import { Grid, TextField, Typography } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import FormDialog from "../../../components/FormDialog";
import { sendDataWithPost } from "../../../services/services";
import { showSuccessMsg } from "../../../utils/toast";

const RemarkDialog = ({ open, onClose, row, isEdit, onSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    handleChange,
    handleSubmit,
    handleBlur,
    values,
    touched,
    errors,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: {
      remarks: "",
    },
    validationSchema: yup.object().shape({
      remarks: yup.string().trim().required("Required").max(500, "Maximum 500 characters"),
    }),
    onSubmit: async (vals) => {
      if (isSubmitting) return;
      setIsSubmitting(true);
      const remarks = (vals.remarks || "").trim();
      const payload =
        isEdit && row?.incoming_summary_id
          ? { action: "update", id: row.incoming_summary_id, remarks }
          : {
              action: "create",
              batch_date: row?.fund_in_date,
              acquirer: row?.acquirer,
              remarks: remarks || "",
            };

      sendDataWithPost(
        "/payout/ingestor/incoming_action_remark/",
        payload,
        null,
        null,
        (response) => {
          showSuccessMsg(
            isEdit ? "Remarks updated successfully" : "Remarks added successfully"
          );
          setIsSubmitting(false);
          onSuccess?.();
          onClose();
        },
        () => {
          setIsSubmitting(false);
        }
      );
    },
  });

  useEffect(() => {
    if (open) {
      if (isEdit && row?.remarks != null) {
        setValues({ remarks: row.remarks || "" });
      } else {
        resetForm();
      }
    }
  }, [open, isEdit, row, setValues, resetForm]);

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleFormSubmit = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isSubmitting) return false;
    handleSubmit(e);
    return false;
  };

  if (!open) return null;

  return (
    <FormDialog
      open={open}
      onClose={handleClose}
      title={isEdit ? "Edit Remarks" : "Add Remarks"}
      handleSubmit={handleFormSubmit}
      loading={isSubmitting}
      disabledSubmit={isSubmitting}
      maxWidth="sm"
      showActions={true}
    >
      <form onSubmit={handleFormSubmit} noValidate>
        <Grid container spacing={2} alignItems="center">
          <Grid item md={4} xs={12}>
            <Typography variant="subtitle1" align="right">
              Remarks *
            </Typography>
          </Grid>
          <Grid item md={8} xs={12}>
            <TextField
              name="remarks"
              value={values.remarks || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              variant="outlined"
              fullWidth
              size="small"
              margin="dense"
              placeholder="Enter remark..."
              error={Boolean(touched.remarks && errors.remarks)}
              helperText={touched.remarks && errors.remarks}
              disabled={isSubmitting}
            />
          </Grid>
        </Grid>
      </form>
    </FormDialog>
  );
};

export default RemarkDialog;
